export const pixelRatio = (): number => {
  return window.devicePixelRatio ?? 1
}

export const container = (): HTMLElement => {
  return document.getElementById('relation_map')
}

export const visibleCanvas = (): HTMLElement => {
  return document.getElementById('visualization')
}

export const hiddenCanvas = (): HTMLElement => {
  return document.getElementById('hidden-visualization')
}

export const noVisibleCanvas = (): boolean => {
  return visibleCanvas() === undefined || visibleCanvas() === null
}

export const width = (): number => {
  return configuration().width
}

export const height = (): number => {
  return configuration().height
}

export const pixelRatioWidth = (): number => {
  return configuration().pixelRatioWidth
}

export const pixelRatioHeight = (): number => {
  return configuration().pixelRatioHeight
}

export const reheat = (): void => {
  globalThis._SIMULATION_.alphaTarget(0.02).restart()
}

export const freeze = (): void => {
  globalThis._SIMULATION_.alphaTarget(0)
}

export const scaleExtent = (): array => {
  if (configuration() !== undefined) {
    return [configuration().scale.extent.min, configuration().scale.extent.max]
  } else {
    return [1, 3]
  }
}

export const scaleCutoff = (): number => {
  if (configuration() !== undefined) return configuration().scale.cutoff
}

export const collideStrength = (): number => {
  if (configuration() !== undefined) return configuration().force.collide.strength
}

export const manyBodyStrength = (): number => {
  if (configuration() !== undefined) return configuration().force.manyBody.strength
}

export const manyBodyStrengthDistanceMin = (): number => {
  if (configuration() !== undefined) return configuration().force.manyBody.distance.min
}

export const manyBodyStrengthDistanceMax = (): number | string => {
  if (configuration() !== undefined) return configuration().force.manyBody.distance.max
}

export const alphaDecay = (): number => {
  if (configuration() !== undefined) return configuration().decay.alpha
}

export const velocityDecay = (): number => {
  if (configuration() !== undefined) return configuration().decay.velocity
}

export const inIframe = (): boolean => {
  try {
    return window.self !== window.top
  } catch (error) {
    return true
  }
}

export const mobile = (): boolean => {
  return !desktop()
}

export const desktop = (): boolean => {
  return window.matchMedia('(min-width: 768px)').matches
}

export const rgb = (hex: string): number[] => {
  hex = hex.replace(/^#/, '')
  if (hex.length === 3) hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2]

  const [r, g, b] = hex.match(/.{2}/g)
  return [parseInt(r, 16), parseInt(g, 16), parseInt(b, 16)]
}

export const luminance = (hex: string): number => {
  const [r, g, b] = rgb(hex)

  return (((r / 255.0) ** 2.2) * 0.2126) + (((g / 255.0) ** 2.2) * 0.7152) + (((b / 255.0) ** 2.2) * 0.0722)
}

const configuration = (): object => {
  return globalThis._CONFIGURATION_
}
